// extracted by mini-css-extract-plugin
export default {"header":"header-ApM34","title":"title-r1fEU","modal":"modal-ylA4I","body":"body-VGxD5","closeIcon":"closeIcon-ghfnl"};